<template>
  <b-tab title="Profissionais" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE PROFISSIONAIS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterProfissionais(filtro)" :fields="fields.profissional">
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="profissional-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pelo nome do profissional."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <profissional-modal ref="editor" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import Profissional from "@/models/Profissional";
import TableFields from "@/tools/TableFields";
import ProfissionalModal from "@/components/modals/inspecao/ProfissionalModal";

export default {
  name: "ProfissionalTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      profissional: new Profissional(),
    };
  },

  components: {
    "profissional-modal": ProfissionalModal,
  },

  methods: {
    adicionar() {
      this.profissional = new Profissional();
      this.$refs.editor.call(this.profissional);
    },

    editar(profissional) {
      this.$refs.editor.call(profissional);
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getFilterProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      profissionalStore,
      getFilterProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped>
#profissional-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
